import { memo } from "react";

import { getElapsedTimePhrase, getFirstName } from "@/utils/helpers";

import { useConversationItemLogic } from "./conversation-item.hook";
import type { TConversationItemConfig } from "./conversation-item.types";

import * as S from "./conversation-item.styles";

const ConversationItem = memo(({
  chatId,
  message,
  userNameFrom,
  userNameTo,
  userEmailFrom,
  userEmailTo,
  unreadMessages,
  userTag,
  detail,
}: TConversationItemConfig) => {
  const {
    nameLastMessage,
    unreadMessagesCounter,
    isBlocked,
    isActive,
    conversationClickHandler,
    vehicleData,
  } = useConversationItemLogic({
    chatId,
    message,
    userNameFrom,
    userNameTo,
    userEmailFrom,
    userEmailTo,
    unreadMessages,
    userTag,
    detail,
  });

  return (
    <S.Conversation
      data-testid="conversation-item"
      data-qa="conversation-item"
      onClick={conversationClickHandler}
      active={isActive}
      unread={unreadMessages}
      isBlocked={isBlocked}
    >
      <S.ContentWrapper unread={unreadMessages}>
        <S.LeftBox>
          <S.VehicleImage
            photoPath={vehicleData.photoPath}
            urlPath={vehicleData.imageUrl}
          />
          <S.Content>
            <S.Title>{vehicleData.title}</S.Title>
            <S.VehicleInfo>{vehicleData.vehicleInfo}</S.VehicleInfo>
            <S.UserName>{vehicleData.userName}</S.UserName>
          </S.Content>
        </S.LeftBox>
        {!isBlocked && (
          <S.RightBox>
            <S.LastMessageTime>
              {getElapsedTimePhrase(message?.sentOn)}
            </S.LastMessageTime>
          </S.RightBox>
        )}
      </S.ContentWrapper>
      {!isBlocked && (
        <S.Message>
          <S.LastMessage>
            {getFirstName(nameLastMessage)}: {message?.message}
          </S.LastMessage>
          {!!unreadMessages && (
            <S.MessageStatus>{unreadMessagesCounter}</S.MessageStatus>
          )}
        </S.Message>
      )}
    </S.Conversation>
  );
});

ConversationItem.displayName = "ConversationItem";
export { ConversationItem };
